import axios from 'axios';
import { keyAccessToken, keyUserId } from '../../../../assets/js/SessionStorageNames';
const saveData = async (entId, data, excelFile = null) => {
    const headers = {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-access-token": localStorage.getItem(keyAccessToken),
        "x-user-id": localStorage.getItem(keyUserId),
    };
    const url = excelFile
        ? `${process.env.REACT_APP_BACKEND_URL}/v1/df-camp/${entId}/send-from-excel-pricelist`
        : `${process.env.REACT_APP_BACKEND_URL}/v1/df-camp/${entId}/send-from-odoo-pricelist`;
    const payload = excelFile
        ? (() => {
            const formData = new FormData();
            formData.append('xlsx', excelFile);
            formData.append('isRegister', data.isRegister);
            formData.append('campaignName', data.campaignName);
            formData.append('pricelistId', data.pricelistId);
            formData.append('pricelistName', data.pricelistName || '');
            formData.append('plusPercent', data.plusPercent);
            formData.append('dateStart', data.dateStart);
            formData.append('dateEnd', data.dateEnd);
            return formData;
        })()
        : {
            isRegister: data.isRegister,
            campaignName: data.campaignName,
            pricelistId: data.pricelistId,
            plusPercent: data.plusPercent,
            dateStart: data.dateStart,
            dateEnd: data.dateEnd
        };

    const res = await axios.post(url, payload, { headers })
    return res
}

export default saveData;